/**
 * Lecture d'une table par clé, sans jamais remonter la chaîne de prototypes : seules les propriétés propres de la table
 * existent. Une clé inconnue (ou `constructor`, `__proto__`...) rend `undefined`, comme une clé absente.
 *
 * Remplace `table[cle]` quand la clé vient d'une donnée (code reçu du serveur, valeur d'un formulaire...) : l'accès par
 * crochets sur une clé non maîtrisée est la faille « object injection ».
 */
export function lookup<T extends object>(table: T, key: PropertyKey | null | undefined): T[keyof T] | undefined {
  if (key === null || key === undefined) {
    return undefined;
  }
  return Object.getOwnPropertyDescriptor(table, key)?.value as T[keyof T] | undefined;
}

/**
 * Comme {@link lookup} pour une clé déjà typée comme clé de la table (énumération, union de littéraux) : le type de retour
 * est celui de la valeur, sans `undefined`. À réserver aux tables couvrant toutes les clés de leur type.
 */
export function pick<T extends object, K extends keyof T>(table: T, key: K): T[K] {
  return Object.getOwnPropertyDescriptor(table, key)?.value as T[K];
}
